export enum UserCurrencyTransactionType {
  None = 0,
  ShopBuy = 1,
  Manual = 2,
  Init = 3,
  FreeCredits = 4,
  GameJoin = 100,
  GameLose = 101,
  GameWin = 102,
  SlotBuy = 200,
  SlotWin = 201,
  LeagueReward = 300,
  MissionReward = 400,
  TournamentBuy = 500,
  TournamentReward = 501,
  LevelReward = 600,
  VillageBuy = 700,
  VillageCollectionReward = 701,
  News = 800,
}
